export interface ILeadRequisition {
  companyInfo: ICompanyInfo | null;
  contactInfo: IContactInfo | null;
  businessNeeds: IBusinessNeed | null;
}

export interface ICompanyInfo {
  duns?: string;
  legalNameOfBusiness: string;
  alternateNameOfBusiness?: string;
  headquaterCountry: string;
  dateOfIncorporation?: string;
  operatedCountry?: string[];
  physicalAddress?: IAddress | null;
  industry: string;
  industryBasic: string;
  isRegSameAsPrimary?: boolean;
  registerAddress: IAddress | null;
  isCompanyGovernmentOwned?: boolean;
  isCompanyVCorPEBacked?: boolean;
  fullNameOfUltimateCompany?: string;
  sicCode?: string;
  naicCode?: string;
  pastYearRevenue?: string;
  forecastYearRevenue?: string;
  website?: string;
  registrationNo?: string;
  companyType?: string;
  isCompanyVCorVPBacked?: boolean;
  address?: string;
  salesSize?: string;
  isCompanySource_Flag?: boolean;
  businessInfo?: IClientInfo;
  global_ultimate_country_name?: string;
}

export interface IAddress {
  streetName?: string;
  city?: string;
  state?: string;
  country?: string;
  zipcode?: string;
}

export interface IContactInfo {
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  mobile: string;
}

export interface BusinessNeed {
  title: string;
  description: string;
  error?: string;
  checked: boolean;
}
export interface IBusinessNeed {
  businessNeeds: BusinessNeed[];
}

export interface IClientInfo {
  referral?: string;
  referralDetails?: string;
}

export interface ICompanyData {
  business_name: string;
  street_address: string;
  city_name: string;
  duns: string;
  address: string;
  global_ultimate_country_name: string;
  sic_naics__c: string;
  industry_sector: string;
  country_name: string[];
  industry: string;
  state_or_province_abbreviation: string;
  secp_city: null;
}

export interface IContactData {
  countryCode: string;
  role: string;
  firstName: string;
  lastName: string;
  contactMethod: string[];
  email: string;
  mobile: string;
  contactInfoConsent: boolean;
}

export const CONTACT_INFO_INIT = {
  countryCode: "",
  role: "",
  firstName: "",
  lastName: "",
  contactMethod: [],
  email: "",
  mobile: "",
  contactInfoConsent: false,
};

export const BUSINESS_NEEDS_INFO_INIT: IBusinessNeed = {
  businessNeeds: [],
};

export interface IGroupCompanyInfo {
  [key: string]: ICompanyInfo[];
}
export interface IDropdownOptions {
  id: string;
  name: string;
}

export interface BusineedsInfo {
  checked: boolean | undefined;
  title: string;
  type: string;
  error?: string;
}
